<template>
  <div class="registration-form">
    <div class="registration-inner" v-if="!doneRegistration">
      <div class="row">
        <div class="col-6">
          <b-form-group
            :id="'registration-short-form-input-firstname-label-' + _uid"
            label="First Name"
            :label-for="'registration-short-form-input-firstname-input-' + _uid"
          >
            <b-form-input
              :id="'registration-short-form-input-firstname-input-' + _uid"
              name="firstname"
              v-model="$v.form.firstname.$model"
              :state="validateState('firstname')"
              :aria-describedby="
                'registration-short-form-input-firstname-feedback-' + _uid
              "
            ></b-form-input>
            <b-form-invalid-feedback
              :id="'registration-short-form-input-firstname-feedback-' + _uid"
            >
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
        <div class="col-6">
          <b-form-group
            :id="'registration-short-form-input-lastname-label-' + _uid"
            label="Last Name"
            :label-for="'registration-short-form-input-lastname-input-' + _uid"
          >
            <b-form-input
              :id="'registration-short-form-input-lastname-input-' + _uid"
              name="lastname"
              v-model="$v.form.lastname.$model"
              :state="validateState('lastname')"
              :aria-describedby="
                'registration-short-form-input-lastname-feedback-' + _uid
              "
            ></b-form-input>
            <b-form-invalid-feedback
              :id="'registration-short-form-input-lastname-feedback-' + _uid"
            >
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
        </div>
      </div>
      <b-form-group
        id="registration-short-form-email"
        label="Email address:"
        label-for="registration-short-form-email"
      >
        <b-form-input
          id="registration-short-form-email"
          v-model="$v.form.email.$model"
          :state="validateState('email')"
          type="email"
          required
        ></b-form-input>
        <b-form-invalid-feedback
          :id="'registration-short-form-input-email-feedback-' + _uid"
        >
          Please enter a valid email address
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        :id="'registration-short-form-telephone-label-' + _uid"
        label="Telephone"
        :label-for="'registration-short-form-telephone-input-' + _uid"
      >
        <b-form-input
          :id="'registration-short-form-telephone-input-' + _uid"
          name="Telephone"
          v-model="$v.form.address.Telephone.$model"
          :state="validateState('Telephone', 'address')"
          :aria-describedby="
            'registration-short-form-telephone-feedback-' + _uid
          "
        ></b-form-input>
        <b-form-invalid-feedback
          :id="'registration-short-form-telephone-feedback-' + _uid"
        >
          Please enter a valid telephone number, no longer than 20 characters.
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        v-if="!show_full_form"
        :id="'registration-short-form-postcode-label-' + _uid"
        label="Postcode"
        :label-for="'registration-short-form-postcode-input-' + _uid"
      >
        <b-input-group>
          <b-form-input
            :id="'registration-short-form-postcode-input-' + _uid"
            name="PostCode"
            v-model="$v.form.address.PostCode.$model"
            :state="validateState('PostCode', 'address')"
            :aria-describedby="
              'registration-short-form-postcode-feedback-' + _uid
            "
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="lookupPostcode"
              >Find Address</b-button
            >
          </b-input-group-append>
        </b-input-group>
      </b-form-group>
      <p v-if="!show_full_form">
        <b-link @click="show_full_form = true"
          >Or enter an address manually...</b-link
        >
      </p>
      <address-input
        no-name
        no-recipient
        no-telephone
        v-if="show_full_form"
        :value="resolved_address"
        @input="setAddress"
      ></address-input>
      <b-form-group
        v-if="show_full_form"
        :id="'registration-short-form-input-password-label-' + _uid"
        label="Your Password"
        :description="passwordStrengthMessage"
        :label-for="'registration-short-form-input-password-input-' + _uid"
      >
        <b-form-input
          :id="'registration-short-form-input-password-input-' + _uid"
          name="password1"
          type="password"
          placeholder="Your password"
          v-model="$v.form.password1.$model"
          :state="validateState('password1')"
          :aria-describedby="
            'registration-short-form-input-password-feedback-' + _uid
          "
        ></b-form-input>
        <b-form-input
          class="mt-1"
          :id="'registration-short-form-input-password2-input-' + _uid"
          name="password2"
          type="password"
          placeholder="Confirm your password"
          v-model="$v.form.password2.$model"
          :state="validateState('password2')"
          :aria-describedby="
            'registration-short-form-input-password2-feedback-' + _uid
          "
        ></b-form-input>
        <b-form-invalid-feedback
          :id="'registration-short-form-input-password2-feedback-' + _uid"
        >
          {{ passwordStrengthErrorMessage }}
        </b-form-invalid-feedback>
      </b-form-group>
      <b-form-group
        v-if="show_full_form"
        :id="'registration-short-form-optin-label-' + _uid"
        description="We are an independent wine merchant and are passionate about our products. From time to time we would like to contact you to let you know about wines that really excite us. We would never, ever pass your details to anyone else."
        :label-for="'registration-short-form-optin-' + _uid"
      >
        <b-form-checkbox
          :id="'registration-short-form-optin-' + _uid"
          v-model="$v.form.opt_in.$model"
          name="opt_in"
          class="mb-2"
          value="1"
          unchecked-value=""
        >
          Sign up to the Bunch newsletter and stay up to date with latest deals,
          special offers, releases and more.
        </b-form-checkbox>
      </b-form-group>
      <address-lookup
        ref="address-lookup"
        :postcode="$v.form.address.PostCode.$model"
        @input="setResolvedAddress"
      ></address-lookup>
      <div class="text-center mb-2">
        <b-button
          variant="success"
          :disabled="$v.$invalid"
          @click="doRegistration"
          >Create an account</b-button
        >
      </div>
      <b-modal
        title="Creating your account..."
        no-close-on-esc
        no-close-on-backdrop
        ok-disabled
        cancel-disabled
        hide-footer
        hide-header-close
        centered
        id="modal-registering"
      >
        <p class="text-center">{{ create_account_message }}</p>
      </b-modal>
    </div>
    <div
      class="registration-complete text-center text-muted"
      v-if="doneRegistration"
    >
      <p>
        Thank you for registering, we believe you already have an account with
        us, please check your email as we have sent you a message to verify your
        account.
      </p>
    </div>
  </div>
</template>

<script>
/* global wp gtag */

import AddressInput from "@/components/AddressInput";
import AddressLookup from "@/components/AddressLookup";
import {
  required,
  email,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";

const passwordStrength = function passwordStrength() {
  if (!this.form.password2) {
    return false;
  }

  if (this.passwordStrength >= 3 && this.passwordStrength < 5) {
    return true;
  }

  return false;
};

export default {
  props: {
    isCheckout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      create_account_message: "",
      doneRegistration: false,
      show_full_form: false,
      resolved_address: {
        Name: "Default",
        Recipient: "",
        Address1: "",
        Address2: "",
        Address3: "",
        City: "",
        Country: "GB",
        PostCode: "",
        Telephone: "",
      },
      form: {
        opt_in: "",
        firstname: "",
        lastname: "",
        email: "",
        password1: "",
        password2: "",
        address: {
          Name: "Default",
          Recipient: "",
          Address1: "",
          Address2: "",
          Address3: "",
          City: "",
          Country: "GB",
          PostCode: "",
          Telephone: "",
        },
      },
    };
  },
  validations() {
    return {
      form: {
        opt_in: {},
        firstname: {
          required,
        },
        lastname: {
          required,
        },
        password1: {
          required,
          passwordStrength,
        },
        password2: {
          required,
          passwordStrength,
        },
        email: {
          required,
          email,
        },
        address: {
          Address1: {
            required,
          },
          Address2: {},
          Address3: {},
          City: {
            required,
          },
          Country: {
            required,
          },
          PostCode: {
            required,
          },
          Telephone: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(20),
          },
        },
      },
    };
  },
  computed: {
    passwordStrength() {
      return wp.passwordStrength.meter(
        this.form.password1,
        wp.passwordStrength.userInputDisallowedList(),
        this.form.password2
      );
    },
    passwordStrengthErrorMessage() {
      if (!this.form.password1) {
        return "Please enter a password";
      }

      if (
        this.passwordStrength >= 3 &&
        this.passwordStrength < 5 &&
        !this.form.password2
      ) {
        return "Please confirm your password";
      }

      switch (this.passwordStrength) {
        case 2:
          return "Weak Password";
        case 3:
          return "";
        case 4:
          return "";
        case 5:
          return "Your passwords don't match";
        default:
          return "Too weak!";
      }
    },
    passwordStrengthMessage() {
      switch (this.passwordStrength) {
        case 2:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
        case 3:
          return "Good Password!";
        case 4:
          return "Strong Password!";
        case 5:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
        default:
          return "Please enter a password of 9 or more characters including upper and lower case letters, numbers and symbols.";
      }
    },
  },
  methods: {
    setAddress(val) {
      this.form.address = { ...val };
    },
    setResolvedAddress(val) {
      this.show_full_form = true;
      this.resolved_address = { ...val };

      this.resolved_address.Telephone = this.form.address.Telephone;
    },
    lookupPostcode() {
      this.$refs["address-lookup"].lookup();
    },
    validateState(name, parent) {
      const { $dirty, $error } = parent
        ? this.$v.form[parent][name]
        : this.$v.form[name];
      return $dirty ? !$error : null;
    },
    async doRegistration() {
      this.create_account_message = "Creating your account...";

      this.$bvModal.show("modal-registering");

      await this.$recaptchaLoaded();
      const token = await this.$recaptcha("register");

      this.$store
        .dispatch("user/register", {
          ...this.form,
          recaptcha: token,
          is_checkout: this.isCheckout,
        })
        .then((response) => {
          gtag("event", "sign_up", {
            method: "Website",
          });

          if (response.data.status === "created") {
            this.create_account_message = "Account created! Logging you in...";
            window.location = "/checkout/";
            // Refresh the page.
          } else if (response.data.status === "exists") {
            this.$bvModal.hide("modal-registering");
            this.$bvModal.msgBoxOk(
              "An account already exists with this email address. Please log in."
            );
            // Please log in.
          } else if (response.data.status === "needs_confirmation") {
            // Please check your email etc.
            this.doneRegistration = true;
            this.$bvModal.hide("modal-registering");
            this.$bvModal.msgBoxOk(
              "Thank you. We believe you already hold an account with Jeroboams. Please check your email and confirm your email address to continue."
            );
          }
        })
        .catch((err) => {
          this.$bvModal.hide("modal-registering");
          this.showError(
            "Error creating your account",
            "Sorry, there was a problem creating your account. Please try again later",
            err
          );
        });
    },
  },
  mounted() {},
  components: {
    AddressInput,
    AddressLookup,
  },
};
</script>